class TolhuinPrecheckout {
  constructor(root) {
    this.root = root;
    this.error = root.querySelector('[data-delivery-error]');
    this.pickupPanel = root.querySelector('[data-pickup-panel]');
    this.widget = root.querySelector('#TolhuinPplWidget');
    this.i18n = root.dataset;
    this.bind();
  }

  bind() {
    this.root.querySelectorAll('input[name="tol-delivery"]').forEach((radio) => {
      radio.addEventListener('change', () => this.selectDelivery(radio.value));
    });
    this.root.querySelector('[data-open-ppl]')?.addEventListener('click', () => this.openPpl());
    this.root.querySelector('[data-precheckout]')?.addEventListener('click', () => this.checkout());
    this.root.querySelector('[data-discount-form]')?.addEventListener('submit', (event) => this.applyDiscount(event));
    this.widget?.addEventListener('ppl-accesspointwidget-select', (event) => this.savePoint(event.detail));
    this.widget?.addEventListener('ppl-accesspointwidget-error', (event) => this.showError(event.detail?.message || this.i18n.i18nPplLoad));
  }

  applyDiscount(event) {
    event.preventDefault();
    const code = new FormData(event.currentTarget).get('discount')?.toString().trim();
    if (!code) return;
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.routes.cart_url)}`;
  }

  selectedMethod() {
    return this.root.querySelector('input[name="tol-delivery"]:checked')?.value || '';
  }

  async selectDelivery(method) {
    this.pickupPanel?.classList.toggle('is-hidden', method !== 'PPL_PICKUP');
    this.clearError();
    const attributes = { delivery_method: method };
    if (method !== 'PPL_PICKUP') Object.assign(attributes, this.emptyPoint());
    try {
      await this.updateAttributes(attributes);
      if (method === 'PPL_PICKUP' && !this.savedPointCode()) this.openPpl();
    } catch (error) {
      this.showError(error.message);
    }
  }

  openPpl() {
    if (!this.widget || this.root.dataset.pplConfigured !== 'true') {
      this.showError(this.i18n.i18nPplNotConfigured);
      return;
    }
    if (typeof this.widget.open === 'function') this.widget.open();
    else this.showError(this.i18n.i18nPplLoading);
  }

  async savePoint(point = {}) {
    const address = point.address || {};
    const attributes = {
      delivery_method: 'PPL_PICKUP',
      ppl_access_point_code: point.code || point.accessPointCode || '',
      ppl_access_point_name: point.name || point.parcelshopName || point.accessPointName || '',
      ppl_access_point_address: point.street || address.street || address.address || '',
      ppl_access_point_city: point.city || address.city || '',
      ppl_access_point_zip: point.zipCode || point.zip || address.zipCode || address.zip || '',
      ppl_access_point_country: point.country || address.country || 'CZ',
    };
    if (!attributes.ppl_access_point_code) {
      this.showError(this.i18n.i18nPointCode);
      return;
    }
    try {
      await this.updateAttributes(attributes);
    } catch (error) {
      this.showError(error.message);
      return;
    }
    this.root.querySelector('input[value="PPL_PICKUP"]').checked = true;
    this.pickupPanel?.classList.remove('is-hidden');
    this.root.querySelector('[data-selected-point]')?.classList.remove('is-hidden');
    this.root.querySelector('[data-point-name]').textContent = attributes.ppl_access_point_name;
    this.root.querySelector('[data-point-address]').textContent =
      `${attributes.ppl_access_point_address}, ${attributes.ppl_access_point_city} ${attributes.ppl_access_point_zip}`;
    this.root.querySelector('[data-point-code]').textContent = attributes.ppl_access_point_code;
    this.clearError();
  }

  async checkout() {
    const method = this.selectedMethod();
    if (!method) {
      this.showError(this.i18n.i18nChooseDelivery);
      return;
    }
    if (method === 'PPL_PICKUP') {
      const code = this.savedPointCode();
      if (!code) {
        this.showError(this.i18n.i18nChoosePickup);
        this.openPpl();
        return;
      }
    }
    try {
      const cart = await this.updateAttributes({ delivery_method: method });
      if (method === 'PPL_PICKUP') {
        const missing = this.missingPickupAddress(cart.attributes || {});
        if (missing.length) {
          this.showError(this.i18n.i18nMissingAddress);
          this.openPpl();
          return;
        }
      }
      window.location.href = this.root.dataset.checkoutUrl;
    } catch (error) {
      this.showError(error.message);
    }
  }

  savedPointCode() {
    return this.root.querySelector('[data-point-code]')?.textContent.trim() || '';
  }

  missingPickupAddress(attributes) {
    return ['ppl_access_point_code', 'ppl_access_point_name', 'ppl_access_point_address', 'ppl_access_point_city', 'ppl_access_point_zip']
      .filter((key) => !attributes[key]?.trim());
  }

  emptyPoint() {
    return {
      ppl_access_point_code: '',
      ppl_access_point_name: '',
      ppl_access_point_address: '',
      ppl_access_point_city: '',
      ppl_access_point_zip: '',
      ppl_access_point_country: '',
    };
  }

  async updateAttributes(attributes) {
    const response = await fetch(this.root.dataset.cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });
    if (!response.ok) throw new Error(this.i18n.i18nSaveFailed);
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) throw new Error(this.i18n.i18nSaveUnconfirmed);
    return response.json();
  }

  showError(message) {
    this.error.hidden = false;
    this.error.textContent = message;
  }

  clearError() {
    this.error.hidden = true;
    this.error.textContent = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tol-precheckout]').forEach((root) => new TolhuinPrecheckout(root));
});
